// Inertia.js + Vue 3 entrypoint.
// Pages are lazy-globbed so Vite emits one chunk per page instead of
// shipping every screen in the first download.
import { createApp, h } from "vue"
import { createInertiaApp, Link } from "@inertiajs/vue3"
import { documentTitle } from "@/composables/documentTitle"
import ConfirmDialogHost from "@/components/feedback/ConfirmDialogHost.vue"
import ToastContainer from "@/components/feedback/ToastContainer.vue"
import "./application.css"

const pages = import.meta.glob("../pages/**/*.vue")

createInertiaApp({
  title: (title) => documentTitle(title),

  resolve: (name) => {
    const page = pages[`../pages/${name}.vue`]
    if (!page) {
      throw new Error(`Inertia page not found: ${name}`)
    }
    return page()
  },

  // Render the active Inertia page alongside the global feedback
  // hosts (confirm dialog + toast container) so `confirm()` from
  // `@/composables/useConfirm` and `toast.*` from `useToast` always
  // have somewhere to render, regardless of layout.
  setup({ el, App, props, plugin }) {
    createApp({
      render: () =>
        h("div", [h(App, props), h(ConfirmDialogHost), h(ToastContainer)]),
    })
      .use(plugin)
      .component("Link", Link)
      .mount(el)
  },
})
